(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/utils/draw.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/utils/draw.js');

'use strict';

const _svs$numbergames$draw = svs.numbergames.draws,
  drawsApi = _svs$numbergames$draw.drawsApi,
  asyncDrawsApi = _svs$numbergames$draw.asyncDrawsApi;
svs.numbergames.game.utils.createGameDraw = _ref => {
  let product = _ref.product,
    draws = _ref.draws;
  if (!svs.numbergames.game.draw) {
    const DrawClass = "".concat(svs.numbergames.productMapping.getProductName(product) || '', "Draw");
    svs.numbergames.game.draw = new svs.numbergames.draws[DrawClass](draws);
    const draw = drawsApi.firstPlayableDraw(product);
    if (!Object.keys(draw).length) {
      (async () => {
        await asyncDrawsApi.firstPlayableDraw(product);
        svs.numbergames.game_app.app.getView().render();
      })();
    }
  }
};

 })(window);